import { AuthContext } from '../../contexts/auth'; 
import { useState, useEffect, useContext } from 'react';
import { listarEquipamentos, listarCompartimentos  } from '../../services/apigateway';

import Cabecalho from '../../components/Cabecalho/cabecalho'; 
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import ProcessandoModal from '../../components/Processamento/processamento';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';

import '../../components/ClienteSelecionado/clienteSelecionado.css';
import { useParams, useLocation } from 'react-router-dom';

export default function Compartimentos({funcao}){
  const location = useLocation();

  const { clienteId, ligaMenu } = useContext(AuthContext);

  const [equipamentos, setEquipamentos] = useState([]);
  const [equipamentoSelected, setEquipamentoSelected] = useState(null);
  const [equipamentoId, setEquipamentoId] = useState(null);
  const [nomeEquipamento, setNomeEquipamento] = useState(null);
  const [compartimentos, setCompartimentos] = useState([]);
  const [compartimentoFiltrado, setcompartimentoFiltrado] = useState([]);
  const [compartimentoPaginado, setcompartimentoPaginado] = useState([]);

  const [loading, setLoading] = useState(true);

  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    {coluna: 'cod_compartimento', cabecalho: 'Código', alinhamento: 'tdtabela'},
    {coluna: 'tip_compartimento', cabecalho: 'Tipo', alinhamento: 'tdtabelaleft'},
    {coluna: 'tip_oleo', cabecalho: 'Fluido', alinhamento: 'tdtabelaleft'},
    {coluna: 'cap_compartimento', cabecalho: 'Capacidade', alinhamento: 'tdtabela'}, 
    {coluna: 'sit_compartimento', cabecalho: 'Situação', alinhamento: 'tdtabela'}, 
    {coluna: 'ação', cabecalho: 'Ação', alinhamento: 'tdtabela'}
  ];

  useEffect(() => {
    loadEquipamentos();
  
    if (location.state?.indice && equipamentos.length != 0) {
      setEquipamentoSelected(location.state.indice);    
      handleChangeEquipamento(location.state.indice);
    }

    return() => {}
  }, []);

  async function loadEquipamentos(){
    try {
      if (!clienteId) {
        setLoading(false);
        return (<></>);
      }

      const response = await listarEquipamentos(clienteId);
      console.log('response Equipamentos em Compartimentos: ', response)
      setEquipamentos(response);
      setEquipamentoSelected('');

    } catch(err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
 }

  function handleChangeEquipamento(valor){
    if (valor) { 
      setEquipamentoSelected(valor);
      setEquipamentoId(equipamentos[valor].cod_equipamento);
      setNomeEquipamento(`${equipamentos[valor].tag_equipamento} - ${equipamentos[valor].mod_equipamento}`)

      loadCompartimentos(valor);
    }
  } 

  async function loadCompartimentos(index){
    try {
      if (!index) {
        setLoading(false);
        return (<></>);
      }

      const result = await listarCompartimentos(clienteId, equipamentos[index].cod_equipamento);

      setCompartimentos(result);

      let dados = filterCompartimentos(result, '');
      setcompartimentoFiltrado(dados);
   
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarCompartimentos(dados, 0, qtdLinhas);
      setcompartimentoPaginado(datas);
      setLoading(false);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);      
    }

    setLoading(false);
  }

  function filterCompartimentos(dados, texto) {
    let data = [];

    dados && dados.filter(item => {return item.tip_compartimento.toLowerCase().includes(texto)}).map(dado => {
      data.push(dado)
    });

    return data; 
  }  
 
  function paginarCompartimentos(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(texto) {
    let dados = filterCompartimentos(compartimentos, texto);
    setcompartimentoFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarCompartimentos(dados, 0, qtdLinhas)
    setcompartimentoPaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarCompartimentos(compartimentoFiltrado, posicao, qtdLinhas);
    setcompartimentoPaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = compartimentoFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(compartimentoFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarCompartimentos(compartimentoFiltrado, 0, valor);
    setcompartimentoPaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...compartimentoFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setcompartimentoFiltrado(dataCopy); 

    let data = paginarCompartimentos(dataCopy, 0, qtdLinhas);
    setcompartimentoPaginado(data); 
    setCurrentPage(0); 
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
        <main>
          <Titulo tela={'Cadastro de Compartimentos'} />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <ProcessandoModal open={loading} message="Aguarde, buscando Compartimentos..." />
          </section>
        </main>
      </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
      <Cabecalho />
      
      <main>
        <Titulo 
          tela={'Cadastro de Compartimentos'} 
          destination='/compartimentos/inclusao/' 
          nomeBase={nomeEquipamento}
          codigoBase={equipamentoId}
          permissao='COMPARTIMENTO_INCLUIR'
        />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
          <Menu />
          <div>  
            <div className="combo-container-conteiner">
              <div className="combo-container">
                <span>
                  <label className="combo-label"> Compartimentos do Equipamento:  </label>
                  <select className="combo-select" value={equipamentoSelected} onChange={e => handleChangeEquipamento(e.target.value)} >
                    <option key='0' value=''>Selecione um Equipamento</option>
                    {equipamentos.map((item, index) => {
                      return(
                        <option key={item.cod_equipamento} value={index}>
                          {item.tag_equipamento} - {item.mod_equipamento} 
                        </option>
                      )
                    })}
                  </select>
                </span>
              </div>
            </div>

            <Tabela
              entidade='Compartimentos' 
              dados={compartimentoPaginado}
              elementos={elementos}
              handleSort={handleSort}
              sortedId={coluna}
              ordem={ordem}
              urlBase='/compartimentos'
              codigoBase={equipamentoId}
              nomeBase={nomeEquipamento}
              indice={equipamentoSelected}
            />

            {qtdPaginas > 1 ? (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {compartimentoFiltrado.length} 
                />
                
                <Paginate
                  qtdPaginas={qtdPaginas}
                  handlePageClick={handlePageClick}
                  currentPage={currentPage}
                />

              </div>
            ) : (
              <div className='pagination-container'>
                <Comandos 
                  linhas = {qtdLinhas}
                  handleQtdLinhas = {handleQtdLinhas}
                  qtdRegistros = {compartimentoFiltrado.length} 
                />
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape versao={Globais.versao}/>
    </div>
    );
  }
  